var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureAks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-0.8 -0.8 17.60 17.60",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.8,
    y: -0.8,
    width: 17.6,
    height: 17.6,
    rx: 8.8,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-aks-color-16__paint0_linear_2372_185)",
    d: "M5.511 2l-2.224.412v3.034l2.224.474 2.232-.894V2.762L5.511 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A6E",
    d: "M3.287 2.412v3.034l2.247.474V2.031l-2.247.381zm.949 2.8l-.63-.124V2.754l.63-.1v2.558zm.98.18l-.724-.118V2.607l.724-.125v2.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-aks-color-16__paint1_linear_2372_185)",
    d: "M10.325 2.039l-2.224.412v3.033l2.224.475 2.225-.902V2.8l-2.225-.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A6E",
    d: "M8.101 2.451v3.033l2.232.475V2.07l-2.232.381zm.941 2.8l-.63-.124V2.793l.63-.1V5.25zm.98.179L9.3 5.313V2.646l.723-.133V5.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-aks-color-16__paint2_linear_2372_185)",
    d: "M3.232 6.184l-2.224.413V9.63l2.224.474 2.232-.894V6.947l-2.232-.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A6E",
    d: "M1 6.597v3.01l2.248.474V6.192L1 6.597zm.941 2.807l-.63-.132V6.94l.63-.109v2.574zm.988.203l-.723-.117V6.791l.723-.124v2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-aks-color-16__paint3_linear_2372_185)",
    d: "M8.031 6.153l-2.224.413v3.033l2.224.482 2.224-.902V6.916l-2.224-.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A6E",
    d: "M5.807 6.566v3.04l2.24.475V6.192l-2.24.374zm.94 2.807l-.63-.132V6.908l.63-.11v2.575zm.98.171l-.723-.116V6.76l.724-.124v2.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-aks-color-16__paint4_linear_2372_185)",
    d: "M12.83 6.192l-2.225.412v3.034l2.225.474 2.232-.894V6.954l-2.232-.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A6E",
    d: "M10.605 6.604v3.003l2.248.474V6.192l-2.248.412zm.95 2.808l-.63-.132V6.947l.63-.11v2.575zm.98.171l-.724-.116V6.799l.723-.125v2.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-aks-color-16__paint5_linear_2372_185)",
    d: "M5.457 10.415l-2.225.405v3.033l2.225.482 2.232-.902v-2.255l-2.232-.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A6E",
    d: "M3.232 10.82v3.033l2.248.483v-3.952l-2.248.436zm.95 2.808l-.63-.132v-2.334l.63-.109v2.575zm.98.179l-.724-.117v-2.675l.723-.125v2.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#azure-aks-color-16__paint6_linear_2372_185)",
    d: "M10.263 10.447l-2.224.412v3.033l2.224.475 2.232-.895V11.21l-2.232-.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#341A6E",
    d: "M8.039 10.859v3.033l2.248.475v-3.89l-2.248.382zm.949 2.808l-.63-.133v-2.333l.63-.109v2.575zm.98.17l-.724-.116v-2.668l.724-.124v2.909z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-aks-color-16__paint0_linear_2372_185",
    x1: 3.287,
    x2: 7.743,
    y1: 3.96,
    y2: 3.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-aks-color-16__paint1_linear_2372_185",
    x1: 8.101,
    x2: 12.55,
    y1: 3.999,
    y2: 3.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-aks-color-16__paint2_linear_2372_185",
    x1: 1.008,
    x2: 5.457,
    y1: 8.144,
    y2: 8.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-aks-color-16__paint3_linear_2372_185",
    x1: 5.807,
    x2: 10.255,
    y1: 8.113,
    y2: 8.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-aks-color-16__paint4_linear_2372_185",
    x1: 10.605,
    x2: 15.062,
    y1: 8.152,
    y2: 8.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-aks-color-16__paint5_linear_2372_185",
    x1: 3.232,
    x2: 7.689,
    y1: 12.376,
    y2: 12.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-aks-color-16__paint6_linear_2372_185",
    x1: 8.039,
    x2: 12.495,
    y1: 12.407,
    y2: 12.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#773ADC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureAks);
export default __webpack_public_path__ + "static/media/azure_aks.735e499a42a9ce3e1bec8d8df1be7244.svg";
export { ForwardRef as ReactComponent };